/**
 * Created by jmartinez on 8/27/18.
 */

const createHistory = require("history").createBrowserHistory;
export default createHistory();
